export default __webpack_public_path__ + "static/media/ContactUs.81ba489f.JPG";